import { WSElementProps } from "@wingspanhq/fe-component-library";
import { Tabs } from "../../../../components/Tabs";
import { usePayeeRowsSummaryQuery } from "../../../../query/search/payee/queries/usePayeeRowsSummaryQuery";
import {
  PayeeRowsQuery,
  PayerPayeeEngagementSearchableStatus,
  PayerPayeeSearchableRequirementsStatus
} from "../../../../services/search";
import {
  PAYEES_ALL_PATH,
  PAYEES_ARCHIVED_PATH,
  PAYEES_COMPLETE_PATH,
  PAYEES_INCOMPLETE_PATH,
  PAYEES_NOT_SIGNED_UP_PATH
} from "../../utils";

export const ContractorsTabs = [
  "all",
  "archived",
  "complete",
  "incomplete",
  "notSignedUp"
] as const;

export type ContractorTab = (typeof ContractorsTabs)[number];

export const ContractorsTabsFilters: Record<ContractorTab, PayeeRowsQuery> = {
  all: {
    filter: {
      searchableStatus: {
        "!=": PayerPayeeEngagementSearchableStatus.Inactive
      }
    }
  },
  notSignedUp: {
    filter: {
      searchableStatus: PayerPayeeEngagementSearchableStatus.NotSignedUp
    }
  },
  incomplete: {
    filter: {
      searchableRequirementsStatus:
        PayerPayeeSearchableRequirementsStatus.Incomplete,
      searchableStatus: {
        in: [
          PayerPayeeEngagementSearchableStatus.NotEligible,
          PayerPayeeEngagementSearchableStatus.Eligible
        ]
      }
    }
  },
  complete: {
    filter: {
      searchableRequirementsStatus:
        PayerPayeeSearchableRequirementsStatus.Complete
    }
  },
  archived: {
    filter: {
      searchableStatus: PayerPayeeEngagementSearchableStatus.Inactive
    }
  }
};

export const DashboardTabs: React.FC<WSElementProps> = props => {
  // Query for all payees (excluding inactive)
  const queryAllPayees = usePayeeRowsSummaryQuery(ContractorsTabsFilters.all);

  // Query for not signed up payees
  const queryNotSignedUp = usePayeeRowsSummaryQuery(
    ContractorsTabsFilters.notSignedUp
  );

  // Query for incomplete payees
  const queryIncomplete = usePayeeRowsSummaryQuery(
    ContractorsTabsFilters.incomplete
  );

  // Query for complete payees
  const queryComplete = usePayeeRowsSummaryQuery(
    ContractorsTabsFilters.complete
  );

  // Query for archived payees
  const queryArchived = usePayeeRowsSummaryQuery(
    ContractorsTabsFilters.archived
  );

  return (
    <Tabs
      {...props}
      tabs={[
        {
          label: "Active",
          path: PAYEES_ALL_PATH,
          badge: queryAllPayees.data?.listSize
        },
        {
          label: "Not signed up",
          path: PAYEES_NOT_SIGNED_UP_PATH,
          badge: queryNotSignedUp.data?.listSize
        },
        {
          label: "Incomplete",
          path: PAYEES_INCOMPLETE_PATH,
          badge: queryIncomplete.data?.listSize
        },
        {
          label: "Complete",
          path: PAYEES_COMPLETE_PATH,
          badge: queryComplete.data?.listSize
        },
        {
          label: "Archived",
          path: PAYEES_ARCHIVED_PATH,
          badge: queryArchived.data?.listSize
        }
      ]}
    />
  );
};
